export default __webpack_public_path__ + "assets/icons/email.afe11865.svg";